import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Solutions", href: "/solutions" },
    { name: "Resources", href: "/resources" },
  ];

  const extraLinks = [
    { name: "Contact Us", href: "/contact" },
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
    { name: "Report Bugs", href: "/report-bugs" },
  ];
  return (
    <footer className="relative bg-white pt-16 sm:pt-24 overflow-hidden border-t border-[#E2E8F0]">
      {/* WAVE TRANSITION */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] transform rotate-180">
        <svg
          className="relative block w-[calc(100%+1.3px)] h-[28px] sm:h-[40px]"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            fill="#F8FAFC"
          ></path>
        </svg>
      </div>

      <div className="mx-auto w-[95%] md:w-[90%] pb-10 sm:pb-12 pt-10 sm:pt-16 relative z-10">
        <div className="grid grid-cols-1 gap-10 sm:gap-12 lg:grid-cols-3">
          {/* COLUMN 1: BRAND & MISSION */}
          <div className="space-y-8 animate-fade-in-up">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center size-10 rounded-xl bg-[#E63946] text-white shadow-lg shadow-[#E63946]/20">
                <span className="material-symbols-outlined">hub</span>
              </div>
              <span className="text-2xl font-black tracking-tighter text-[#0B1C2D]">
                ContactHQ
              </span>
            </div>
            <p className="text-sm leading-7 text-[#64748B] max-w-sm">
              Helping teams and developers in India build smarter customer
              connections through better automation and unified form management.
            </p>
          </div>

          {/* COLUMN 2: REDESIGNED MIDDLE SECTION (PLATFORM & EXTRA) */}
          <div className="grid grid-cols-2 gap-8 animate-fade-in-up [animation-delay:200ms]">
            {/* Main Platform Links */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-[#0B1C2D] mb-6">
                Platform
              </h3>
              <ul className="space-y-4">
                {navLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-[#64748B] hover:text-[#E63946] transition-all duration-300 relative group inline-block"
                    >
                      {link.name}
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#E63946] group-hover:w-full transition-all duration-300"></span>
                    </Link>
                  </li>
                ))}
                <li>
                  <a
                    href="https://rahul.contacthq.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#64748B] hover:text-[#E63946] transition-all duration-300 relative group inline-block"
                  >
                    Founder
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#E63946] group-hover:w-full transition-all duration-300"></span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Extra Pages (Legal/Contact) */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-[#0B1C2D] mb-6">
                Company
              </h3>
              <ul className="space-y-4">
                {extraLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-sm text-[#64748B] hover:text-[#E63946] transition-all duration-300 relative group inline-block"
                    >
                      {link.name}
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#E63946] group-hover:w-full transition-all duration-300"></span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* COLUMN 3: CONTACT & LOCATION */}
          <div className="space-y-6 animate-fade-in-up [animation-delay:400ms]">
            <h3 className="text-sm font-bold uppercase tracking-widest text-[#0B1C2D] mb-6">
              Get In Touch
            </h3>
            <div className="space-y-4">
              <div className="flex items-center gap-4 group">
                <div className="size-10 rounded-full bg-red-50 flex items-center justify-center text-[#E63946] group-hover:bg-[#E63946] group-hover:text-white transition-all animate-pulse">
                  <span className="material-symbols-outlined text-sm">
                    mail
                  </span>
                </div>
                <span className="text-sm font-medium text-[#0B1C2D]">
                  support@contacthq.in
                </span>
              </div>
              <div className="flex items-center gap-4 group">
                <div className="size-10 rounded-full bg-red-50 flex items-center justify-center text-[#E63946] group-hover:bg-[#E63946] group-hover:text-white transition-all animate-pulse [animation-delay:500ms]">
                  <span className="material-symbols-outlined text-sm">
                    call
                  </span>
                </div>
                <span className="text-sm font-medium text-[#0B1C2D]">
                  +91 9732149101
                </span>
              </div>
              <div className="flex items-center gap-4 group">
                <div className="size-10 rounded-full bg-red-50 flex items-center justify-center text-[#E63946] group-hover:bg-[#E63946] group-hover:text-white transition-all animate-pulse [animation-delay:1000ms]">
                  <span className="material-symbols-outlined text-sm">
                    location_on
                  </span>
                </div>
                <span className="text-sm font-medium text-[#0B1C2D]">
                  Kolkata, India
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM LEGAL BAR */}
        <div className="mt-20 pt-8 border-t border-[#E2E8F0] flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs font-medium text-[#94A3B8]">
            © 2026 ContactHQ Inc. All rights reserved. Designed for speed.
          </p>
          <div className="flex gap-4">
            <span className="text-[10px] font-black uppercase text-[#94A3B8]">
              Secure
            </span>
            <span className="text-[10px] font-black uppercase text-[#94A3B8]">
              Fast
            </span>
            <span className="text-[10px] font-black uppercase text-[#94A3B8]">
              Reliable
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
